import {EyebrowBanner as PrimerEyebrowBanner} from '@primer/react-brand'

import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import type {GenericContent} from '../../../../brand/lib/types/contentful'

import styles from './EyebrowBanner.module.css'

type Props = {
  contentfulContent: GenericContent
}

export function EyebrowBanner(props: Props) {
  const {contentfulContent} = props
  const {heading = '', links, media} = contentfulContent.fields

  const link = links?.[0]
  const visual = media?.[0]

  const analyticsAttrs = {
    ...getAnalyticsEvent({
      action: heading,
      tag: 'link',
      context: 'eyebrow_banner',
      location: 'hero',
    }),
  }

  return (
    <PrimerEyebrowBanner href={link?.fields.href || ''} {...analyticsAttrs} className={styles.banner}>
      {visual ? (
        <PrimerEyebrowBanner.Visual className={styles.visual}>
          <img src={visual.fields.asset.fields.file.url} alt={visual.fields.description || ''} />
        </PrimerEyebrowBanner.Visual>
      ) : null}

      <PrimerEyebrowBanner.Heading className={styles.heading}>{heading}</PrimerEyebrowBanner.Heading>
    </PrimerEyebrowBanner>
  )
}

try{ EyebrowBanner.displayName ||= 'EyebrowBanner' } catch {}